import { useMemo } from 'react'
import { useDataFormat, useDataValue } from 'Simple/Data.js'
import { isAppointmentScheduled } from 'Data/format.js'

export default function useDataTransform(props, data) {
  let selected_user_id = useDataValue({
    viewPath: props.viewPath,
    context: 'auth',
    path: 'access_token_data.vaxiom_user_id',
  })
  let visible_in_schedule = useDataFormat({
    viewPath: props.viewPath,
    context: 'event',
    format: item =>
      !isAppointmentScheduled(item.appointment) ||
      item.appointment.booking.state === 'SCHEDULED',
  })

  return useMemo(() => {
    if (!data) return data

    return {
      ...data,
      selected_user_id: Number(selected_user_id),
      /**
       * If the appointment is not scheduled, or if it is scheduled but the patient
       * has not checked in, we set the visible_in_schedule value to be `true` as the
       * notes added then, would most probably be relevant to scheduling
       */
      visible_in_schedule,
    }
  }, [data, selected_user_id, visible_in_schedule])
}
